import {Component, inject, OnInit} from '@angular/core';
import {RouterLink} from "@angular/router";
import {DataService} from "../../services/data.service";

@Component({
    selector: 'app-generic-list-list',
    imports: [RouterLink],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-rectangle-list me-2"></i>Diverse Listen <small class="text-muted">({{entries?.length}})</small></h3>
                </div>

                <button type="button" class="btn btn-primary mb-3" [routerLink]="['/list', 0]">Liste anlegen</button>

                @if (entries?.length > 0) {
                    <div class="table-responsive">
                        <table class="table table-striped table-hover mb-0 pointer">
                            <thead>
                            <tr>
                                <th style="width: 300px" (click)="setOrder('name')">
                                    Name
                                    @if (predicate == 'name') {
                                        <i class="fa-solid" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                    }
                                </th>
                                <th style="width: 300px" (click)="setOrder('name')">
                                    Einträge
                                    @if (predicate == 'item_count') {
                                        <i class="fa-solid" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                    }
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (entry of entries; track entry.id) {
                                    <tr [routerLink]="['/list', entry.id]">
                                        <td>{{ entry.name }}</td>
                                        <td>{{ entry.item_count }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>
    `
})
export class GenericListListComponent implements OnInit {

    private dataService = inject(DataService);

    entries!: any[] | null;
    predicate = 'name';
    reverse = false;

    ngOnInit(): void {
        this.listEntries();
    }

    setOrder(order: string): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.listEntries();
    }

    listEntries(): void {
        this.entries = null;
        this.dataService.request('GenericList/listAll', {
            order: this.predicate,
            reverse: this.reverse,
        }).subscribe(response => {
            this.entries = response.lists;
        });
    }
}
